<div class="p-4 md:p-6 bg-gray-50 min-h-screen font-sans">
  
  <!-- Header Section: Reduced margins and gaps -->
  <div class="flex flex-col md:flex-row md:items-end justify-between gap-3 mb-5">
    
    <!-- Title -->
    <h1 class="text-2xl font-bold text-bule-900 leading-tight">
      Submitted Stock
    </h1>
    
    <!-- Independent Related Total Panel: Compact Design -->
    <div class="bg-green-100 px-5 py-3 rounded-lg border border-gray-200 shadow-sm min-w-[180px]">
      <p class="text-gray-500 text-xs font-semibold uppercase tracking-wider">
        Total Submitted Stock
      </p>
      <p class="text-2xl font-bold text-gray-800 leading-none mt-1">
        {{ stockItems?.length }}
      </p>
    </div>

  </div>

  <!-- Main Content Container -->
  <div class="bg-white border border-gray-200 rounded-lg shadow-sm">
    
    <!-- Filter Section -->
    <div class="p-4 border-b border-gray-200 flex flex-col md:flex-row gap-4 items-center justify-between">
      <!-- Search -->
      <div class="w-full md:w-1/2">
        <input 
          type="text" 
          placeholder="Search product code..." 
          class="w-full border border-gray-300 rounded px-4 py-2 text-gray-600 focus:outline-none focus:border-blue-500 text-sm transition-colors"
        >
      </div>
      
      <!-- Dropdowns -->
      <!-- <div class="flex gap-3 w-full md:w-auto">
        <div class="relative w-full md:w-40">
          <select class="w-full border border-gray-300 rounded px-4 py-2 text-sm appearance-none bg-white text-gray-700 cursor-pointer focus:outline-none hover:border-gray-400">
            <option>Category</option>
            <option>Ring</option>
            <option>Necklace</option>
            <option>Bracelet</option>
          </select>
          <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-500">
            <svg class="fill-current h-4 w-4" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
          </div>
        </div>

        <div class="relative w-full md:w-40">
          <select class="w-full border border-gray-300 rounded px-4 py-2 text-sm appearance-none bg-white text-gray-700 cursor-pointer focus:outline-none hover:border-gray-400">
            <option>Month</option>
            <option>May 2024</option>
            <option>June 2024</option>
          </select>
          <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-500">
            <svg class="fill-current h-4 w-4" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
          </div>
        </div>
      </div> -->
    </div>

    <!-- Table Section -->
    <div class="overflow-x-auto">
      <table class="w-full text-left border-collapse min-w-[800px]">
        <thead>
          <tr class="bg-gray-50 border-b border-gray-200 text-gray-900 text-xs font-semibold uppercase tracking-wider">
            <th class="p-4">Product Code</th>
            <th class="p-4">Barcode</th>
            <th class="p-4">Category</th>
            <th class="p-4">Weight</th>
            <th class="p-4">Assigned Qty</th>
            <th class="p-4">Owner</th>
            <th class="p-4">Submitted Date</th>
            <th class="p-4">Status</th>
            <th class="p-4">Return Reason</th>
            <!-- <th class="p-4">Actions</th> -->
          </tr>
        </thead>
        <tbody class="text-sm">
          <tr *ngFor="let item of visibleItems" class="border-b border-gray-100 hover:bg-gray-50 transition-colors">
            <td class="p-4 text-gray-900 font-medium">{{ item.std_item_code }}</td>
            <td class="p-4 text-gray-900 font-medium">{{ item.std_barcode }}</td>
            <td class="p-4 text-gray-600">{{ item.std_item_category }}</td>
            <td class="p-4 text-gray-600">{{ item.std_total_wt }} gm</td>
            <td class="p-4 text-gray-600">{{ item.std_quantity | number:'1.0-0'}}</td>
            <td class="p-4 text-gray-600">{{ "Test" }}</td>
            <td class="p-4 text-gray-600">{{ item.std_returned_at | date:'dd MMM yyyy, hh:mm a' }}</td>
            <td class="p-4">
              <span
                class="px-2.5 py-0.5 rounded-full text-xs font-medium
                       bg-purple-50 text-purple-700 border border-purple-100">
                Submitted
              </span>
            </td>
            <td class="p-4 text-gray-600 max-w-xs">
              <span
                *ngIf="item.std_return_reason; else noReason"
                class="block text-xs bg-yellow-50 border border-yellow-200 text-yellow-800 rounded px-2 py-1">
                {{ item.std_return_reason }}
              </span>
            
              <ng-template #noReason>
                <span class="text-gray-400 italic text-xs">—</span>
              </ng-template>
            </td>
            <!-- <td class="p-4">
              <div class="flex items-center">
                <button class="px-3 py-1.5 text-xs font-medium border border-gray-300 rounded-l-md text-gray-700 hover:bg-gray-50 bg-white transition-colors">
                  View
                </button>
                <button class="px-2 py-1.5 bg-blue-600 rounded-r-md border border-blue-600 text-white hover:bg-blue-700 transition-colors flex items-center justify-center">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor" class="w-3.5 h-3.5">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                  </svg>
                </button>
              </div>
            </td> -->
          </tr>
          
          <tr *ngIf="visibleItems.length === 0">
            <td colspan="9" class="p-8 text-center text-gray-500">
              No submitted stock records found.
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination Footer -->
    <div class="p-4 border-t border-gray-200 flex flex-col sm:flex-row justify-between items-center gap-4 text-gray-600 text-sm">
      <span class="font-medium">
        {{ startRange }}–{{ endRange }} of {{ totalItems }}
      </span>
      
      <div class="flex gap-2">
        <button (click)="firstPage()" [disabled]="currentPage === 1" 
          class="p-1.5 border border-gray-200 rounded hover:bg-gray-100 disabled:opacity-40 disabled:cursor-not-allowed transition-colors">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
            <path stroke-linecap="round" stroke-linejoin="round" d="M18.75 19.5l-7.5-7.5 7.5-7.5m-6 15L5.25 12l7.5-7.5" />
          </svg>
        </button>

        <button (click)="prevPage()" [disabled]="currentPage === 1" 
          class="p-1.5 border border-gray-200 rounded hover:bg-gray-100 disabled:opacity-40 disabled:cursor-not-allowed transition-colors">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
          </svg>
        </button>

        <button (click)="nextPage()" [disabled]="currentPage === totalPages" 
          class="p-1.5 border border-gray-200 rounded hover:bg-gray-100 disabled:opacity-40 disabled:cursor-not-allowed transition-colors">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
            <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
          </svg>
        </button>

         <button (click)="lastPage()" [disabled]="currentPage === totalPages" 
         class="p-1.5 border border-gray-200 rounded hover:bg-gray-100 disabled:opacity-40 disabled:cursor-not-allowed transition-colors">
         <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
           <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 4.5l7.5 7.5-7.5 7.5m-6-15l7.5 7.5-7.5 7.5" />
         </svg>
       </button>
      </div>
    </div>

  </div>
</div>